import { SelectFormInput } from "components/inputs";
import {
  useContractOrderRequestShipTos,
  useRequestOrderFormSelectedOptions,
} from "hooks/api/requestOrder";
import useSingleOptionAsFormDefault from "hooks/useSingleOptionAsFormDefault";

const ShipToSelect = ({ id }: { id: string }) => {
  const selectedOptions = useRequestOrderFormSelectedOptions();

  const {
    data: shipToOptions,
    isInitialLoading,
    isRefetching,
  } = useContractOrderRequestShipTos(selectedOptions);

  useSingleOptionAsFormDefault(id, shipToOptions);

  const isLoading = isInitialLoading || isRefetching;

  return (
    <SelectFormInput
      id={id}
      label="Ship To"
      options={shipToOptions}
      isLoading={isLoading}
      isDisabled={isLoading || (shipToOptions?.length ?? 0) <= 1}
      placeholder="Select location"
    />
  );
};

export default ShipToSelect;
